import { GatsbyBrowser } from 'gatsby';

export const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] =
  () => {
    document.querySelector('html')?.removeAttribute('data-no-smooth-scroll');
  };
